import { render, staticRenderFns } from "./NumberOfInjuriesIllnesses.vue?vue&type=template&id=1398c5f2&scoped=true&"
import script from "./NumberOfInjuriesIllnesses.vue?vue&type=script&lang=js&"
export * from "./NumberOfInjuriesIllnesses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1398c5f2",
  null
  
)

export default component.exports